import {handleActions} from 'redux-actions'
import * as ActionTypes from './actionTypes'
import {arrayToMap} from "../../../atUtils"
import {ManagementAssignmentsSelection, UserManagementConstants} from '../../../constants'
import {TabKeys, UserTeamAssignmentType} from '../constants'
import {CLOSE_ALL_PANELS} from '../../../administration/userManagement/common/actionTypes'

const initialState = {
    show: false,
    loaded: false,
    loading: false,
    selectedTab: TabKeys.ACCOUNT_SETTINGS,
    saving: false,
    userCreated: false,
    invitationSent: false,
    showFutureInvitation: false,
    manageAssignments: {
        managementAssignmentsSelection: ManagementAssignmentsSelection.SELECTED,
        addedTaskIds: [],
        addedProjectIds: [],
        addedProjectIdsExcludingSelf: [],
        addedCustomerIds: [],
        addedCustomerIdsExcludingSelf: [],
        taskCountsByProjects: {},
        projectCountsByCustomers: {},
        customersCount: 0,
        projectsOfCustomerCount: 0,
        tasksOfProjectCount: 0,
    },
    tasksMap: {},
    copyUserId: null,
    approversByGroupIds: {},
    passwordValidationRequired: false,

    defaultUserInfo: {
        firstName: null,
        lastName: null,
        middleInitial: null,
        username: null,
        email: null,
        password: null,
        retypedPassword: null,
        userGroupId: null,
        timeZoneGroupId: null,
        hireDate: (new Date()).toJSON(),
        releaseDate: null,
        enabled: false,
        enabledInOtherProduct: false,
        overtimeLevel: UserManagementConstants.OVERTIME_OFF,
        accessRights: [],
        rates: [],
        requiresTTApproval: false,
        initialSchedule: [],
        defaultInitialSchedule: true,
        workSchedule: [],
    },
    defaultTeamAssignments: {
        teamAssignmentType: UserTeamAssignmentType.NO,
        assignedGroups: [],
        assignedUsers: [],
        assignedUsersCount: 0,
    },
    defaultManageAssignments: {
        managementAssignmentsSelection: ManagementAssignmentsSelection.SELECTED,
        addedTaskIds: [],
        addedProjectIds: [],
        addedCustomerIds: [],
        addedProjectIdsExcludingSelf: [],
        addedCustomerIdsExcludingSelf: [],
        taskCountsByProjects: {},
        projectCountsByCustomers: {}
    }
}

export default handleActions({
    [ActionTypes.CREATE_USER_PANEL_TAB_SET]: (state, {payload: tabKey}) => ({...state, selectedTab: tabKey}),
    [ActionTypes.LOADING_SET]: (state, {payload: loading}) => ({...state, loading}),
    [ActionTypes.SHOW_FUTURE_INVITATION_SET]: (state, {payload: showFutureInvitation}) => ({...state, showFutureInvitation}),
    [ActionTypes.MANAGE_ASSIGNMENTS_SET]: (state, {payload: manageAssignments}) => ({...state, manageAssignments}),
    [ActionTypes.PASSWORD_VALIDATION_REQUESTED]: (state) => ({
        ...state,
        passwordValidationRequired: true
    }),
    [ActionTypes.PASSWORD_VALIDATION_DONE]: (state) => ({
        ...state,
        passwordValidationRequired: false
    }),
    [ActionTypes.CUSTOMERS_COUNT_SET]: (state, {payload: customersCount}) => ({
        ...state,
        manageAssignments: {
            ...state.manageAssignments,
            customersCount
        }
    }),
    [ActionTypes.PROJECTS_COUNT_SET]: (state, {payload: projectsOfCustomerCount}) => ({
        ...state,
        manageAssignments: {
            ...state.manageAssignments,
            projectsOfCustomerCount
        }
    }),
    [ActionTypes.TASKS_COUNT_SET]: (state, {payload: tasksOfProjectCount}) => ({
        ...state,
        manageAssignments: {
            ...state.manageAssignments,
            tasksOfProjectCount
        }
    }),
    [ActionTypes.RESET_CREATE_USER_PANEL_STATE]: (state) => ({
        ...state,
        selectedTab: TabKeys.ACCOUNT_SETTINGS,
        saving: false,
        userCreated: false,
        invitationSent: false,
        showFutureInvitation: false,
        manageAssignments: {
            managementAssignmentsSelection: ManagementAssignmentsSelection.SELECTED,
            addedTaskIds: [],
            addedProjectIds: [],
            addedProjectIdsExcludingSelf: [],
            addedCustomerIds: [],
            addedCustomerIdsExcludingSelf: [],
            taskCountsByProjects: {},
            projectCountsByCustomers: {},
            customersCount: 0,
            projectsOfCustomerCount: 0,
            tasksOfProjectCount: 0,
        },
        tasksMap: {},
        copyUserId: null,
        approversByGroups: {},
    }),
    [ActionTypes.MANAGE_ASSIGNMENTS_TASKS_ADD]: (state, {payload: tasks}) => ({
        ...state,
        tasksMap: {
            ...state.tasksMap,
            ...arrayToMap(tasks)
        }
    }),
    [ActionTypes.SAVE_USER]: (state) => ({
        ...state,
        saving: true
    }),
    [ActionTypes.SAVE_USER_SUCCESS]: (state, {payload: {invitationSent = false}}) => ({
        ...state,
        userCreated: true,
        saving: false,
        invitationSent
    }),
    [ActionTypes.SAVE_USER_FAILURE]: (state) => ({
        ...state,
        saving: false
    }),
    [ActionTypes.TOGGLE_CREATE_USER_PANEL]: (state, {payload: isShow}) => ({
        ...state,
        show: isShow
    }),
    [ActionTypes.LOADED_SET]: (state, {payload: loaded}) => ({
        ...state,
        loaded,
    }),
    [ActionTypes.DEFAULT_USER_INFO_SET]: (state, {payload: changedProperties}) => ({
        ...state,
        defaultUserInfo: {
            ...state.defaultUserInfo,
            ...changedProperties,
        }
    }),
    [ActionTypes.DEFAULT_TEAM_ASSIGNMENTS_SET]: (state, {payload: changedProperties}) => ({
        ...state,
        defaultTeamAssignments: {
            ...state.defaultTeamAssignments,
            ...changedProperties,
        }
    }),
    [ActionTypes.DEFAULT_MANAGE_ASSIGNMENTS_SET]: (state, {payload: changedProperties}) => ({
        ...state,
        defaultManageAssignments: {
            ...state.defaultManageAssignments,
            ...changedProperties,
        }
    }),
    [ActionTypes.COPY_USER_CHANGED]: (state, {payload: copyUserId}) => ({
        ...state,
        copyUserId,
    }),
    [ActionTypes.APPROVERS_BY_GROUPS_SET]: (state, {payload: approversByGroupIds}) => ({
        ...state,
        approversByGroupIds,
    }),
    [CLOSE_ALL_PANELS]: (state) => ({
        ...state,
        show: false,
        loaded: false,
        loading: false,
        saving: false,
        userCreated: false,
        invitationSent: false,
        showFutureInvitation: false,
    }),
}, initialState)


// WEBPACK FOOTER //
// ./web/js/panels/user/createPanel/reducer.js